import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
} from '@mui/material';
import JsonView from '@uiw/react-json-view';
import { IOType } from './WorkflowExecutionDetails';
import { useTranslation } from 'react-i18next';

interface StepIODialogProps {
  ioType: IOType;
  content: object;
  open: boolean;
  close: () => void;
}

const PREFIX = 'StepIODialog';

const classes = {
  title: `${PREFIX}-title`,
  content: `${PREFIX}-content`,
  actions: `${PREFIX}-actions`,
};

const RootDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.title}`]: {
    padding: 0,
    margin: theme.spacing(2),
  },
  [`& .${classes.content}`]: {
    padding: theme.spacing(2),
    height: 500,
    width: 500,
  },
  [`& .${classes.actions}`]: {
    margin: theme.spacing(2),
    padding: 0,
  },
}));

export default function StepIODialog({
  open,
  ioType,
  content,
  close,
}: StepIODialogProps) {
  const { t } = useTranslation('common');
  const title =
    ioType === 'input'
      ? t('workflows.stepDialogTitleInput')
      : t('workflows.stepDialogTitleOutput');
  return (
    <RootDialog open={open}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <JsonView displayDataTypes={false} value={content} />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button variant="contained" color="primary" onClick={close}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </RootDialog>
  );
}
